import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import type { DayState } from '@daily/shared';
import { dayStateFromHour } from '@/lib/time';

const VALID: DayState[] = ['morning', 'afternoon', 'evening', 'night'];

function isDayState(v: string | null): v is DayState {
  return !!v && VALID.includes(v as DayState);
}

export function useDayState(): DayState {
  const [params] = useSearchParams();
  const override = params.get('state');

  const [auto, setAuto] = useState<DayState>(() => dayStateFromHour(new Date().getHours()));

  useEffect(() => {
    const tick = () => setAuto(dayStateFromHour(new Date().getHours()));
    const interval = setInterval(tick, 60_000);
    tick();
    return () => clearInterval(interval);
  }, []);

  return isDayState(override) ? override : auto;
}
